import * as React from 'react';
import { Input, Select, Form, Modal } from 'antd';
import { observer } from 'mobx-react-lite';
import { Connection } from '../models';
import { RulesStores } from '../stores';
import { ConnectionResult } from '../types';
import { FormInstance } from 'antd/lib/form';
import { EncryptedInput } from '../../common/components';
import { ConnectionReadOnlyCheckbox } from '../components';

type Props = {
    form: FormInstance;
} & RulesStores;
const TextArea = Input.TextArea;
export const ConnectionEditPage: React.FC<Props> = ({ RuleExternalConnections, form }) => {
    const store = RuleExternalConnections;

    const [connStringValue, setConnStringValue] = React.useState(store?.editableConnection?.connectionString);

    const handleSubmit = (values: ConnectionResult) => {
        const connection = new Connection(values);
        if (!connection.isReadOnly) {
            Modal.confirm({
                title: 'Are you sure?',
                content:
                    'Are you sure you want to save this connection without Read-only? If not, go back and enable Read-only to protect the SICS database.',
                okText: 'OK',
                cancelText: 'Cancel',
                onOk: () => {
                    store!.save(connection, store!.editableConnection!.id);
                }
            });
        } else {
            store!.save(connection, store!.editableConnection!.id);
        }
    };

    if (!store!.editableConnection) {
        return <Form form={form} />;
    }

    const handleConnectionStringChange = (val: string) => {
        setConnStringValue(val);
        form.setFieldsValue({
            connectionString: val
        });
    };

    const conn = store!.editableConnection!;
    return (
        <Form
            form={form}
            onFinish={handleSubmit}
            layout="vertical"
            id="edit-rd-connection-form"
            data-id="edit-rd-connection-dialog-form"
        >
            <Form.Item label="Id" name="id" initialValue={conn.id}>
                <Input disabled />
            </Form.Item>
            <Form.Item
                initialValue={conn.name}
                label="Name"
                name="name"
                rules={[
                    {
                        required: true,
                        message: 'Please input connection name!'
                    }
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                initialValue={conn.connectionType}
                label="Connection Type"
                name="connectionType"
                rules={[
                    {
                        required: true,
                        message: 'Please input connection type!'
                    }
                ]}
            >
                <Select>
                    <Select.Option value={'SqlServer'}>SqlServer</Select.Option>
                    <Select.Option value={'MongoDb'}>MongoDb</Select.Option>
                </Select>
            </Form.Item>
            <Form.Item
                initialValue={conn.connectionString}
                label="Connection String"
                name="connectionString"
                rules={[
                    {
                        required: true,
                        message: 'Please input connection string!'
                    }
                ]}
            >
                <EncryptedInput
                    changeHandler={handleConnectionStringChange}
                    initialValue={store?.editableConnection.connectionString}
                >
                    <TextArea onChange={e => handleConnectionStringChange(e.target.value)} value={connStringValue} />
                </EncryptedInput>
            </Form.Item>
            <ConnectionReadOnlyCheckbox initialValue={store?.editableConnection?.isReadOnly} />
        </Form>
    );
};

export default observer(ConnectionEditPage);
